// Vehicle On boarding Form Steps
export const VEHICLE_ONBOARDING_FORM = {
  SUPPLIER_DETAILS: {
    step_name: "Supplier Details",
    step_number: 0
  },
  CAR_RELATED_DETAILS: {
    step_name: "Car Related Details",
    step_number: 1
  },
  PAYMENT_DETAILS: {
    step_name: "Payment Details",
    step_number: 2
  },
  CHARGES_BY_SELLER: {
    step_name: "Freight Charges by Seller",
    step_number: 3
  },
  SELLER_INVOICE: {
    step_name: "Seller Invoice",
    step_number: 4
  }
};

export const monthsList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const primaryVehicleDetailsAccordionHeading = [
  { name: "Property", bgcolor: "#002238", width: "auto", color: "white", id: "1" },
  { name: "Active", bgcolor: "#002238", width: "auto", color: "white", id: "2" },
  { name: "Onboarding", bgcolor: "#E7EAEF", width: "17%", color: "#002238", id: "3" },
  { name: "Refurb/Triage", bgcolor: "#E7EAEF", width: "17%", color: "#002238", id: "4" },
  { name: "EE/Glasses", bgcolor: "#E7EAEF", width: "17%", color: "#002238", id: "5" },
  { name: "Custom", bgcolor: "#E7EAEF", width: "15%", color: "#002238", id: "6" },
  { name: "Actions", bgcolor: "#002238", width: "7%", color: "white", id: "7" }
];

export const ServiceHistoryAccordionHeadings = [
  { name: "Service date", id: "1" },
  { name: "Odometer (at time of service)", id: "2" },
  { name: "Name of service centre", id: "3" },
  { name: "Source", id: "4" }
];

export const serviceHistoryStatus = [
  { statusColor: "GREEN", bgcolor: "#C4E8C1", color: "#006200" },
  { statusColor: "BLUE", bgcolor: "#E6F1F8", color: "#0071BC" },
  { statusColor: "RED", bgcolor: "#FDCED3", color: "#B32624" },
  { statusColor: "YELLOW", bgcolor: "#FEF4E9", color: "#EF6E0B" }
];

export const warrantyStatus = [
  { id: "ACTUAL", name: "Actual", bgcolor: "#C4E8C1", color: "#006200" },
  { id: "PENDING", name: "Pending", bgcolor: "#FEF4E9", color: "#EF6E0B" },
  { id: "ESTIMATED", name: "Estimated", bgcolor: "#E6F1F8", color: "#0071BC" }
];

export const holdsHeading = [
  { name: "Date", id: "1" },
  { name: "Hold type", id: "2" },
  { name: "Comments", id: "3" },
  { name: "Action", id: "4" }
];
export const inActiveHoldsHeading = [
  { name: "Date", id: "1" },
  { name: "Hold type", id: "2" },
  { name: "Comments", id: "3" },
  { name: "Resolved on", id: "4" }
];

export const pricingCardHeadings = [
  { name: "Date", id: "1" },
  { name: "Price", id: "2" },
  { name: "Price Difference", id: "3" },
  { name: "Sale Price", id: "4" },
  { name: "Discount", id: "5" }
];

export const getHoldsTypeValues = (type, holds, comment) => {
  const returnValue = holds.filter((hold) => {
    if (hold.key === type) {
      const { value } = hold;
      return value;
    }
    return "";
  });

  if (comment) {
    return `${returnValue[0].value} - ${comment}`;
  }

  return returnValue[0].value;
};

export const getPriceBreakDown = (paymentDetails) => {
  const details = [];
  Object.entries(paymentDetails).forEach(([key, value]) => {
    switch (key) {
      case "salePriceExcGST":
        details.push({ title: "Sale price (excl. GST)", price: value ? `$${value}` : "$0" });
        break;
      case "gstOnSalePrice":
        details.push({ title: "GST on sale price", price: value ? `$${value}` : "$0", padding: true });
        break;
      case "administrationPriceExcGST":
        details.push({ title: "Administration fee (excl. GST)", price: value ? `$${value}` : "$0" });
        break;
      case "gstOnAdminFee":
        details.push({ title: "GST on admin fee", price: value ? `$${value}` : "$0", padding: true });
        break;
      case "processingFeeExclGST":
        details.push({ title: "Processing fee (excl. GST)", price: value ? `$${value}` : "$0" });
        break;
      case "gstOnProcessingFee":
        details.push({ title: "GST on processing fee", price: value ? `$${value}` : "$0", padding: true });
        break;
      case "otherChargesExclGST":
        details.push({ title: "Other charges (excl. GST)", price: value ? `$${value}` : "$0" });
        break;
      case "gstOnOtherCharges":
        details.push({ title: "GST on other charges", price: value ? `$${value}` : "$0", padding: true });
        break;
      case "freightChargesExclGST":
        details.push({ title: "Freight charges (excl. GST)", price: value ? `$${value}` : "$0" });
        break;
      case "gstOnFreightCharges":
        details.push({ title: "GST on freight charges", price: value ? `$${value}` : "$0", padding: true });
        break;
      case "advanceCredit":
        details.push({ title: "Advance credit", price: value ? `$${value}` : "$0" });
        break;
      case "fuelCharges":
        details.push({ title: "Fuel charges by seller", price: value ? `$${value}` : "$0" });
        break;

      default:
        break;
    }
  });
  return details;
};

export const publishingChecklist = [
  "Sourcing QC approved",
  "EE/Glass's Sync",
  "Refurb complete",
  "Publishing QC",
  "Photo QC",
  "Price",
  "No holds",
  "No active recall",
  "VAS Car Category"
  // "Not already published",
  // "Not sold"
];

export const videographyChecklist = ["Video Capture", "Video QC", "Script QC", "Audio QC", "Final Video"];

export const REGISTRATION_DOCUMENT_CHECKLIST = ["Acquisition", "De-registration", "RWC", "Registration", "Transfer"];
export const REGISTRATION_DOCUMENT_C2B_WHOLESALE = ["Acquisition", "De-registration"];

export const WARRANTY_HEADING = [
  { name: "Date", id: "1" },
  { name: "Appointment ID", id: "2" },
  { name: "Vin", id: "3" },
  { name: "Warranty Date", id: "4" },
  { name: "Odometer", id: "5" },
  { name: "Status", id: "6" }
];

export const pipelineFiltersPillKeyValue = (key, value, isHeading, filtersList) => {
  if (filtersList.length > 0) {
    if (isHeading) {
      const item = filtersList.filter((filter) => filter.key === key);
      return item[0].title;
    }
    const parentItem = filtersList.filter((filter) => filter.key === key);
    const childItem = parentItem[0].values.filter((x) => x.id === value);

    return childItem[0].title;
  }
  return null;
};

export const BULK_UPLOAD_TABLE_HEADING = [
  {
    name: "File name",
    id: "1"
  },
  {
    name: "Type",
    id: "2"
  },
  {
    name: "Date",
    id: "3"
  },
  {
    name: "Processed",
    id: "4"
  },
  {
    name: "Uploaded by",
    id: "5"
  },
  {
    name: "Actions",
    id: "6"
  }
];
export const RECALL_DETAILS_HEADING = ["Date", "Recall no.", "Campaign no.", "Stage", "Actions"];
export const RECALL_RESOLVED_HEADING = ["Date", "Recall no.", "Campaign no.", "Comment", "Stage", "Actions"];
export const generateArrayOfYears = (startYear) => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = startYear; i <= currentYear; i++) {
    years.push(i.toString());
  }
  return years;
};

export const pipelineFilterValueMapping = {};

export const recallStagesMapping = {
  OUTSTANDING: [
    { title: "Repair booked", id: "BOOKED" },
    { title: "Blocked", id: "BLOCKED" },
    {
      title: "Resolved",
      id: "RESOLVED"
    }
  ],
  POSSIBLE: [
    { title: "Outstanding", id: "OUTSTANDING" },
    { title: "Resolved", id: "RESOLVED" }
  ],
  BOOKED: [{ title: "Repair completed", id: "POSSIBLE" }],
  BLOCKED: [
    { title: "Repair booked", id: "BOOKED" },
    { title: "Repair completed", id: "POSSIBLE" },
    { title: "Resolved", id: "RESOLVED" }
  ],
  RESOLVED: [{ title: "Outstanding", id: "OUTSTANDING" }]
};

export const bulkUpdateMapping = {
  OUTSTANDING: [
    { title: "Repair booked", id: "BOOKED" },
    { title: "Blocked", id: "BLOCKED" }
  ],
  BOOKED: [],
  BLOCKED: [{ title: "Repair booked", id: "BOOKED" }]
};

export const HOME_PAGE_LIMIT = 10;
export const DEFAULT_PAGE_LIMIT = 20;
export const DEFAULT_CURRENT_PAGE = 1;

export const REMOVEABLE_PARAMS_KEYS = ["searchText", "currentPage", "pageLimit"];

export const WARRANTY_END_DATE = "warrantyEndDate";
export const ODOMETER = "odometer";
export const UNLIMITED_ODOMETER = "unlimitedOdometer";

export const VIEW_FILE_FILTERS = [
  { title: "Done", id: "DONE" },
  { title: "Fail", id: "FAILED" }
];

export const refurbMasterDataHeading = [
  "Stock ID",
  "App ID",
  "MMY",
  "Colour",
  "Workstream",
  "Buffer Zone",
  "Submitted by",
  "Date & Time"
];
export const dailyReportsDetailHeading = [
  "Stock ID",
  "MMYC",
  "Check-in Time",
  "Check-out Time",
  "Duration",
  "Current Buffer",
  "Submitted by",
  "Comments"
];
export const buffersDetailHeading = [
  "Stock ID",
  "MCMY",
  "Workstream",
  "Next Workstation",
  "Time in Buffer",
  "In Progress"
];

export const technicianViewDetailHeading = [
  "Stock ID",
  "CMMY",
  "Clock on Time",
  "Clock off Time",
  "Clocked Time",
  "Workstation",
  "Actions"
];
export const nonLabourJobsHeading = ["Non Labour Job", "Clock on Time", "Clock off Time", "Clocked Time", "Actions"];
export const refurbHomeHeading = ["Stock ID", "App ID", "MMY", "Colour", "Workstream", "Submitted by", "Date & Time"];
export const clockedOnHeading = ["Technician", "Stock ID", "Workstation", "Clock on Time"];
export const clockedOffHeading = ["Technician", "Workstation", "Time since Clock off"];
export const loggedOffHeading = ["Technician", "Workstation", "Last Activity"];
export const monthlyViewHeading = [
  "Workstation",
  "Total",
  "Sold",
  "Lot Maintenance",
  "Production",
  "Monthly Target",
  "Daily Target",
  "Run Rate %",
  "Daily Average",
  "Required Daily Average"
];
export const workorderV2Heading = [
  "Stock ID",
  "Car Details",
  "Job Status",
  "Workstation",
  "Prod Age",
  "D-Mech",
  "Parts Age",
  "Parts Status",
  "Workflow Status",
  "Vehicle Segment",
  "Actions"
];
export const buffersViewHeading = [
  "Line",
  "Total",
  "Cost Triage",
  "Mech Triage",
  "PDR",
  "Rims",
  "Panel",
  "Mech Shop",
  "QA",
  "Photo",
  "Sold QC  ",
  "RWC",
  "Sold Detail",
  "Storage"
];
export const monthlyUpdateViewHeading = ["Workstation", "Monthly Target", "Daily Target"];
export const bufferUpdateViewHeading = ["Workstations", "Buffer Limit"];

export const validateEmail = (emailString) => {
  const regx =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regx.test(emailString);
};

export const WORK_ORDER_DROPDOWN_REPAIRS_HEADING = ["Item", "Stage", "Time", "Est."];

export const WORK_ORDER_DROPDOWN_ASSIGN_PARTS_HEADING = [
  "Part No.",
  "Invoice No.",
  "Description",
  "QTY",
  "Cost",
  "Status"
];

export const WORK_ORDER_DROPDOWN_OTHER_PARTS_HEADING = [
  "Part No.",
  "Invoice No.",
  "Description",
  "QTY",
  "Cost",
  "Status"
];

export const STATUS_COLORS = {
  GREEN: {
    color: "#006200",
    bgcolor: "#C4E8C1"
  },
  ORANGE: {
    color: "#EF6E0B",
    bgcolor: "#FEF4E9"
  },
  RED: {
    color: "#B32624",
    bgcolor: "#FDCED3"
  }
};

export const MIN_ORDER_QTY = 1;
export const MAX_ORDER_QTY = 100;
export const ORDER_QTY_LIMIT = 1000;

export const ORDER_STATUS_CREATE_MODE = [
  {
    label: "In Stock",
    value: "IN_STOCK"
  },
  {
    label: "On order",
    value: "ON_ORDER"
  },
  {
    label: "RTS",
    value: "RTS"
  }
];

export const ORDER_STATUS_EDIT_MODE = [
  ...ORDER_STATUS_CREATE_MODE,
  {
    label: "Wrong Entry",
    value: "WRONG_ENTRY"
  }
];

export const WORKFLOW_STATUS = [
  { title: "Triage In Progress", id: "TRIAGE_IN_PROCESS" },
  { title: "Sourcing Review", id: "SOURCING_REVIEW" },
  { title: "WSM Review", id: "WSM_REVIEW" },
  {
    title: "Refurb In Progress",
    id: "REFURBISHMENT_IN_PROCESS"
  },
  {
    title: "Refurb Complete",
    id: "REFURBISHMENT_COMPLETE"
  }
];
export const PART_STATUS = [
  { title: "No Parts Assigned", id: "NO_PARTS_ASSIGNED" },
  { title: "All Parts Ordered", id: "ALL_PARTS_ORDERED" },
  {
    title: "Awaiting Quotation",
    id: "AWAITING_QUOTATION"
  },
  { title: "Partially Ordered", id: "PARTIALLY_ORDERED" },
  { title: "All Parts Arrived", id: "ALL_PARTS_ARRIVED" },
  {
    title: "No Parts Required",
    id: "NO_PARTS_REQUIRED"
  },
  {
    title: "Package Ready",
    id: "PACKAGE_READY"
  }
];
export const DMECH_FILTER = [
  { title: "0", id: "0" },
  { title: "1", id: "1" },
  { title: "2", id: "2" },
  { title: "3", id: "3" }
];
export const PROD_AGE_FILTER = [
  { title: "< 3d", id: "3" },
  { title: "< 5d", id: "5" },
  { title: "< 10d", id: "10" },
  { title: "< 20d", id: "20" }
];
export const SOURCE_FILTER = [
  { name: "B2B", key: "B2B" },
  { name: "C2B", key: "C2B" },
  { name: "Trade In", key: "TRADE_IN" }
];

export const ORDER_PARTS_HEADING = [
  {
    title: "Part Number",
    id: "partNumber"
  },
  {
    title: "Description",
    id: "description"
  },
  {
    title: "QTY",
    id: "quantity"
  },
  {
    title: "Price",
    id: "price"
  },
  {
    title: "Sub Total",
    id: "subTotal"
  },
  {
    title: "GST",
    id: "gst"
  },
  {
    title: "Actions",
    id: "actions"
  }
];

export const sourceFilterMap = {
  key: "source",
  title: "Source",
  type: "MULTISELECT",
  values: [
    {
      id: "B2B",
      title: "B2B"
    },
    {
      id: "C2B",
      title: "C2B"
    },
    {
      id: "TRADE_IN",
      title: "Trade In"
    }
  ]
};

export const ALL = "All";
export const COMPLETED = "Completed";
export const BUFFERS = "Buffers";
export const TIME_CLOCKED = "Time clocked";
export const NO_TIME_CLOCKED = "No time clocked";
export const PRODUCTION = "Production";
export const SOLD = "Sold";
export const LOT_MAINTENANCE = "Lot Maintenance";

export const VIEWS = ["All", "Completed", "Buffers"];
export const BUFFER_VIEWS = ["All", "No time clocked", "Time clocked"];
export const BUFFER_DETAIL_VIEWS = ["All", "Production", "Sold", "Lot Maintenance"];
export const ALL_VIEW_KEYS = ["COMPLETED", "AWAITING"];
export const COMPLETED_VIEW_KEYS = ["COMPLETED"];
export const BUFFERS_VIEW_KEY = ["AWAITING"];
export const ALL_BUFFER_KEYS = "";
export const TIME_CLOCKED_KEYS = "TIME_CLOCKED";
export const NO_TIME_CLOCKED_KEY = "NO_TIME_CLOCKED";
export const PRODUCTION_KEY = "PRODUCTION";
export const SOLD_KEY = "SOLD";
export const LOT_MAINTENANCE_KEY = "LOT_MAINTENANCE";

export const USER_INFO = "userInfo";

export const VEHICLE_SUMMARY_TABS = {
  VEHICLE_DETAILS: "vehicle-details",
  SOURCING: "sourcing",
  DATAVALIDATION: "data-validation",
  PUBLISHING: "publishing",
  MARKETPLACE: "marketplace",
  RECALL: "recall",
  REVIEW: "review",
  VIDEOGRAPHY: "VIDEOGRAPHY"
};

export const getDatesInMonth = (month, year) => {
  const lastDay = new Date(year, month, 0).getDate();
  const datesArray = Array.from({ length: lastDay }, (_, index) => index + 1);
  return datesArray;
};

export const technicianTimeArr = [
  // "00:00",
  // "01:00",
  // "02:00",
  // "03:00",
  // "04:00",
  // "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00"
  // "20:00",
  // "21:00",
  // "22:00",
  // "23:00"
  // "24:00"
];

export const technicianViewTimeArr = () => {
  const technicianViewTimeArr = [];
  // Define start and end times
  const startTime = "06:00";
  // const startTime = "00:00";
  // const endTime = "20:55";
  const endTime = "19:55";
  // const endTime = "23:55";

  // Convert start and end times to Date objects
  const startDate = new Date(`2000-01-01T${startTime}:00`);
  const endDate = new Date(`2000-01-01T${endTime}:00`);

  // Loop through time slots with 5-minute intervals
  const currentTime = startDate;
  while (currentTime <= endDate) {
    const formattedTime = currentTime.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });

    technicianViewTimeArr.push({
      dataIndex: formattedTime,
      title: formattedTime.split(":")[1] // Extract minutes
    });

    // Increment time by 5 minutes
    currentTime.setMinutes(currentTime.getMinutes() + 5);
  }
  return technicianViewTimeArr;
};
